import { OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { firstMatching } from '../utils/array';
var DropdownComponent = /** @class */ (function () {
    function DropdownComponent() {
        this.showNullOption = false;
        this.placement = 'bottom-left';
        this.initialized = false;
        this.propagateChange = function () {
        };
        this.propagateTouched = function () {
        };
    }
    DropdownComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (!this.initialized && this.options) {
            this.initialized = true;
        }
        // Reset the selection if options have changed and no longer contain the (previously) selected value, and if we can select something else
        if (this.selection && changes.options && this.options && this.options.length) {
            var currentlySelected = firstMatching(this.options, function (o) { return o.value === _this.selection; });
            if (!currentlySelected) {
                this.select(this.options[0]);
            }
        }
    };
    Object.defineProperty(DropdownComponent.prototype, "visibleOptions", {
        get: function () {
            if (this.showNullOption) {
                return this.options;
            }
            else {
                return this.options.filter(function (o) { return o.value != null; });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DropdownComponent.prototype, "selectionName", {
        get: function () {
            var _this = this;
            // NOTE: There may be a valid match with nullish value. If there isn't, then let us consider that an initialization time issue.
            var selectedOption = firstMatching(this.options, function (o) { return o.value === _this.selection; });
            if (selectedOption) {
                return selectedOption.name();
            }
            else if (this.selection == null) {
                return '';
            }
            throw new Error('Dropdown options do not contain supposedly selected value.');
        },
        enumerable: true,
        configurable: true
    });
    DropdownComponent.prototype.getIdIdentifier = function (option, index) {
        return option.idIdentifier ? option.idIdentifier() : index;
    };
    DropdownComponent.prototype.isSelected = function (option) {
        return this.selection === option.value;
    };
    DropdownComponent.prototype.select = function (option) {
        this.selection = option.value;
        this.propagateChange(option.value);
    };
    DropdownComponent.prototype.writeValue = function (obj) {
        this.selection = obj;
    };
    DropdownComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    DropdownComponent.prototype.registerOnTouched = function (fn) {
        this.propagateTouched = fn;
    };
    return DropdownComponent;
}());
export { DropdownComponent };
